import { combineReducers } from 'redux';
import search from './redux/search';
import meganav from './redux/meganav';

const appReducer = (state, action) => {
  return combineReducers({ search, meganav })(state, action);
};

export default appReducer;
